// Libs
import React from 'react';
import { ReactElement } from 'react';
// App
import styles from './filters.module.scss';
import { FiltersProps } from './filters.interfaces';
import TimePeriodFilters from './time-period-filters';
import SubFilters from './sub-filters';
import { DateRangePicker, Stack } from 'ui-components';
import { TIME_PERIOD } from './filters.constants';
import { TIME_PERIOD_FILTERS, TIME_PERIOD_FILTERS_WITH_CUSTOM_PERIOD } from './time-period-filters.constants';
import useFilters from './filters.hook';

const Filters = (props: FiltersProps): ReactElement => {
  const { filters: customFilters, afterTimePeriodFilters, shouldAllowCustomPeriod } = props;
  const { navigationDate, selectedTimePeriod } = customFilters;
  const {
    filters,
    handleSelectTimePeriodFilter,
    handleSelectSubFilter,
    handleGotoPrevious,
    handleGotoNext,
    handleCustomPeriodChange,
  } = useFilters(props);
  const timePeriods = (shouldAllowCustomPeriod && TIME_PERIOD_FILTERS_WITH_CUSTOM_PERIOD) || TIME_PERIOD_FILTERS;
  const isCustomPeriodSelected = selectedTimePeriod == TIME_PERIOD.CUSTOM;

  return (
    <Stack mt={2}>
      <div className={styles.timePeriodRow}>
        <Stack direction="row" className={styles.container}>
          <TimePeriodFilters
            value={filters.selectedTimePeriod}
            periods={timePeriods}
            onChange={handleSelectTimePeriodFilter}
          />
        </Stack>
        {afterTimePeriodFilters}
      </div>
      <Stack mt={1} direction="row" alignItems="center" width="100%" className={styles.container}>
        {isCustomPeriodSelected && (
          <div className={styles.customPeriod}>
            <DateRangePicker
              value={filters.customPeriod}
              onChange={handleCustomPeriodChange}
              placeholder="Choisissez une période"
              size="small"
              shouldOpenOnMount
              shouldDisableFuture
            />
          </div>
        )}
        {!isCustomPeriodSelected && (
          <SubFilters
            endDate={navigationDate}
            timePeriod={selectedTimePeriod}
            onChange={handleSelectSubFilter}
            onClickPrevious={handleGotoPrevious}
            onClickNext={handleGotoNext}
            shouldShowPreviousButton
            shouldShowNextButton
          />
        )}
      </Stack>
    </Stack>
  );
};

export default Filters;
